export const knowledgeBaseConstants = {
    KNOWLEDGE_BASE_SUCCESS: 'KNOWLEDGE_BASE_SUCCESS',
    KNOWLEDGE_BASE_REQUEST: 'KNOWLEDGE_BASE_REQUEST',
    KNOWLEDGE_BASE_FAILURE: 'KNOWLEDGE_BASE_FAILURE',
};
